module.exports = __webpack_public_path__ + "static/sbs-b068e8263fe42f355be1d1687c6f190f.jpg";